<template>
  <div class="kpi-tile" :class="{ 'kpi-tile--boxed': !!borderColor }" :style="borderColor ? { borderTopColor: borderColor } : null">
    <div class="kpi-tile__head">
      <span class="kpi-tile__label">{{ label }}</span>
      <a-tooltip v-if="tooltip" :title="tooltip">
        <span class="kpi-tile__info">i</span>
      </a-tooltip>
    </div>

    <span class="kpi-tile__value" :style="{ color: valueColor, fontSize: valueFontSize }">{{ value }}</span>

    <span v-if="caption" class="kpi-tile__caption" :style="{ color: captionColor }">{{ caption }}</span>

    <a-progress
      v-if="progress !== null"
      :percent="progress"
      :stroke-color="progressColor"
      :show-info="false"
      :stroke-width="6"
      class="kpi-tile__progress"
    />

    <div v-if="monthDelta || yearDelta" class="kpi-tile__deltas">
      <span v-if="monthDelta" :style="{ color: monthColor }">mês {{ monthDelta }}</span>
      <span v-if="yearDelta" :style="{ color: yearColor }">ano {{ yearDelta }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KpiTile',

  props: {
    label: { type: String, required: true },
    tooltip: { type: String, default: '' },
    value: { type: [String, Number], required: true },
    valueColor: { type: String, default: '#212121' },
    valueFontSize: { type: String, default: '26px' },
    caption: { type: String, default: '' },
    captionColor: { type: String, default: '#9C948C' },
    progress: { type: Number, default: null },
    progressColor: { type: String, default: '#FF5722' },
    monthDelta: { type: String, default: '' },
    monthColor: { type: String, default: '#388E3C' },
    yearDelta: { type: String, default: '' },
    yearColor: { type: String, default: '#388E3C' },
    // borda superior colorida usada nos tiles de "Cotações e pedidos" (seção 1)
    borderColor: { type: String, default: '' },
  },
};
</script>

<style lang="scss" scoped>
.kpi-tile {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.kpi-tile--boxed {
  background: #FAF8F6;
  border: 1px solid #EFEAE4;
  border-radius: 8px;
  border-top: 3px solid;
  padding: 14px;
}

.kpi-tile__head {
  display: flex;
  align-items: flex-start;
  gap: 5px;
  line-height: 1.2;
}

.kpi-tile__label {
  font-size: 12px;
  color: #7A736C;
  font-weight: 600;
  letter-spacing: .02em;
}

.kpi-tile--boxed .kpi-tile__label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: .04em;
}

.kpi-tile__info {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 1px solid #C8C1BA;
  color: #9C948C;
  font-size: 9px;
  font-weight: 700;
  cursor: help;
  flex: none;
}

.kpi-tile__value {
  font-family: 'Baloo 2', 'DM Sans', sans-serif;
  font-weight: 700;
  line-height: 1;
}

.kpi-tile__caption {
  font-size: 11px;
  font-weight: 700;
  line-height: 1.25;
}

.kpi-tile__progress {
  margin: 2px 0 0;
  line-height: 1;
}

.kpi-tile__deltas {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 11px;
  font-weight: 600;
}
</style>
